
<div *ngIf="canManageFunctionAppsSubject.asObservable() | async as canManageFunctionApps" class="card">

    <div class="card-body">
        <h5 class="card-title">Azure function app versioning management</h5>
        <br>
        <br>

        <h6>Function app server status</h6>
        <div *ngIf="serverListDataSource | async as serverList; else loading" class="list-container">
            <dx-data-grid [dataSource]="serverList" height="100%" [showBorders]="true">
                <dxo-selection
                [showCheckBoxesMode]="'none'"
              ></dxo-selection>
                <dxi-column
                dataField="isOnline"
                caption="Status"
                [width]="100"
                [allowFiltering]="false"
                [allowSorting]="false"
                cellTemplate="cellTemplate"
              ></dxi-column>
              <div *dxTemplate="let data of 'cellTemplate'">
                <ng-container *ngIf="data.value">
                    <div class="led-green" title="Online"></div>
                </ng-container>
                <ng-container *ngIf="!data.value">
                    <div class="led-red" title="Offline"></div>
                </ng-container>
              </div>
              <dxi-column dataField="name"></dxi-column>
              <dxi-column dataField="slot"></dxi-column>
              <dxi-column dataField="version"></dxi-column>
              <dxi-column dataField="exception"></dxi-column>
              <!-- <div *dxTemplate="let item of 'item'">
                  {{item |json}}
                  <div class="led-red"></div>
                  <div class="led-green"></div>
                <div class="product">
                  <img src="{{ item.name }}" />
                  <div>{{ item.Name }}</div>
                  <div class="price">{{
                    item.Price | currency: "USD":"symbol":"1.0"
                  }}</div>
                </div>
              </div> -->
            </dx-data-grid>
          </div>

        <!-- <div *ngIf="dataObservable | async as data; else loading">
        </div> -->
        <ng-template #loading>Loading....</ng-template>


        <br>
        <br>

        <div *ngIf="serverListDataSource | async as serverList; else loading" class="list-container">
        <h6>Select company</h6>
        <div *ngIf="companyList | async as companies">
            <dx-select-box [searchEnabled]="true" [items]="companies" displayExpr="fullIdentifier" valueExpr="id" (onValueChanged)="selectCompany($event)"></dx-select-box>
        </div>
        </div>

        <div *ngIf="links$ | async as links">
            <div *ngIf="serverListDataSource | async as serverList; else loading" class="list-container">
            <dx-data-grid [dataSource]="links" height="100%" [showBorders]="true">
                <dxo-selection
                [showCheckBoxesMode]="'none'"
              ></dxo-selection>

              <dxi-column dataField="id" [width]="50" caption="Link ID"></dxi-column>
              <dxi-column dataField="linkName" caption="Link name"></dxi-column>
              <dxi-column dataField="dName" caption="From -> To"></dxi-column>
              <dxi-column dataField="fromDName" caption="From"></dxi-column>
              <dxi-column dataField="toDName" caption="To"></dxi-column>
              <dxi-column
              dataField="functionAppSlot"
              caption="Function app version"
              [width]="200"
              [allowFiltering]="false"
              [allowSorting]="false"
              cellTemplate="cellTemplate"
            ></dxi-column>

              <div *dxTemplate="let data of 'cellTemplate'">
                <dx-select-box
                [dataSource]="serverList"
                [value]="data.value"
                placeholder="No custom version selected"
                displayExpr="name"
                valueExpr="slot"
                (onValueChanged)="updateLinkVersion($event, data.data.id)"
              ></dx-select-box>
              </div>

            </dx-data-grid>
        </div>
        </div>
    </div>
</div>
